<template>

    <Toast/>

    <MenuFinancialCompact v-if="userStore.user?.roles?.includes('ROLE_ISORISE')"/>
    <MenuHealthCompact v-else/>

    <div class="px-6 surface-overlay relative">

        <div v-show="activeTab === 1" class="grid">
            <div class="col-12 md:col-12">
                <div class="card p-fluid">

                    <ul class="list-none py-2 px-0 m-0 flex align-items-center font-medium overflow-x-auto w-full">
                        <li class="pr-3"><a class="cursor-pointer">Help</a></li>
                        <li class="px-2"><i class="pi pi-angle-right text-900"></i></li>
                        <li class="px-2"><a class="cursor-pointer text-900 white-space-nowrap">User Manual</a></li>
                    </ul>

                    <h3>User Manual Overview</h3>

                    <div class="grid">
                        <ul class="list-none p-0 m-0 flex lg:align-items-center flex-column lg:flex-row select-none">
                            <li>
                                <a @click="callWelcomePage" v-ripple
                                   class="flex p-3 align-items-center text-600 hover:text-900 hover:surface-100 font-medium border-round cursor-pointer transition-colors transition-duration-150 p-ripple">
                                    <i class="pi pi-plus-circle mr-2"></i>
                                    <span>Back to Quick Introduction to IsoEvolve</span>
                                </a>
                            </li>
                        </ul>
                    </div>

                    <div class="px-4 py-8 md:px-6 lg:px-8">
                        <div class="font-bold text-5xl text-900 mb-3">Detailed Information on IsoEvolve</div>
                        <div class="text-700 line-height-3 text-xl mb-6">
                            Please read through the information below and select the option that you would like to review.
                        </div>

                        <div class="flex flex-column xl:flex-row gap-4 align-items-stretch">
                            <div class="flex-1 flex shadow-2 surface-card border-round flex-column md:flex-row">
                                <img src="images/blocks/feature/feature-1.png" alt="Image" class="border-round-left"
                                     style="max-height: 234px"/>
                                <div class="p-4">
                                    <div class="flex justify-content-between mb-3">
                                        <span class="text-orange-500 font-medium">Introduction</span>
                                    </div>
                                    <div class="font-medium text-900 mb-3 line-height-3">Why IsoEvolve Is Required for Healthcare Practitioners and Small Business Owners</div>
                                    <div class="line-height-3 text-lg text-900 mb-3">
                                        For many healthcare practitioners and small business owners, professional training focuses primarily on service delivery. Skills related to running a practice or business — such as managing records, finances, scheduling, and compliance — are often learned later, through experience.
                                    </div>

                                    <Button type="button" icon="pi pi-filter-slash" label="Access"
                                            class="p-button-outlined p-ml-2" @click="callChapter1()"/>
                                </div>

                            </div>

                            <div class="flex-1 flex shadow-2 surface-card border-round flex-column md:flex-row">
                                <img src="images/blocks/feature/feature-2.png" alt="Image" class="border-round-left"
                                     style="max-height: 234px"/>
                                <div class="p-4">
                                    <div class="flex justify-content-between mb-3">
                                        <span class="text-teal-500 text-lg font-medium">Accessibility</span>
                                    </div>
                                    <div class="font-medium text-lg text-900 mb-3 line-height-3">How to Access IsoEvolve
                                    </div>
                                    <div class="line-height-3 text-lg text-900 mb-3">
                                        To access IsoEvolve, you need a valid username and password.
                                    </div>

                                    <Button type="button" icon="pi pi-filter-slash" label="Access"
                                            class="p-button-outlined p-ml-2" @click="callChapter2()"/>
                                </div>
                            </div>
                        </div>
                    </div>


                </div>
            </div>
        </div>
    </div>

    <IsoEvolveFooter/>

</template>

<script>
import IsoEvolveFooter from "@/components/heading/authentication/IsoEvolveFooter.vue";
import MenuHealthCompact from "@/components/menu/health/MenuHealthCompact.vue";
import {useUserStore} from "@/stores/UserStore";
import UserService from "@/service/UserService";
import userService from "@/service/UserService";
import MenuFinancialCompact from "@/components/menu/famodule/MenuFinancialCompact.vue";

export default {
    components: {
        MenuFinancialCompact,
        IsoEvolveFooter, MenuHealthCompact
    },
    setup() {
        const userStore = useUserStore()

        return {
            userStore
        }
    },
    async mounted() {
        try {
            await UserService.getUserPing();
        } catch (e) {
            this.userStore.clearUser();
            this.$router.push("login");
            return;
        }

        if (!this.userStore.user.id) {
            this.userStore.clearUser();
            this.$router.push('login');
            return;
        }

        await this.loadCompanyContext();
    },
    data() {

        return {
            profile: {},
            skipWelcome: true,
            userConfiguration: {},
            activeTab: 1
        }
    },
    watch: {
        'userStore.activeCompanyId': {
            immediate: false,
            async handler(newCompanyId, oldCompanyId) {
                if (!newCompanyId || newCompanyId === oldCompanyId) {
                    return;
                }

                await this.loadCompanyContext();
            }
        }
    },
    methods: {
        closeAllMenus() {
            document.body.click(); // triggers hideOnOutsideClick

            document.querySelectorAll('.p-component-overlay, .p-menu-overlay, .p-overlay, .p-tieredmenu-overlay')
                .forEach(el => el.remove());
        },
        safeNavigate(target) {
            this.closeAllMenus();
            setTimeout(() => {
                this.$router.push(target);
            }, 0);
        },
        async loadCompanyContext() {
            try {
                // Attempt to get user data
                const userData = await UserService.getUser(this.userStore.user.id);
                this.profile = userData.data;
            } catch (e) {
                this.userStore.clearUser();
                this.$router.push('login');
                return;
            }

            this.profile.companyId = this.userStore.activeCompanyId;

            const [userConfigurationData] = await Promise.all([
                UserService.getUserConfig(this.userStore.user.id),
            ]);

            this.userConfiguration = userConfigurationData.data;

            if (this.userConfiguration.showWelcome === 'Y') {
                this.skipWelcome = false;
            } else {
                this.skipWelcome = true;
            }
        },
        callWelcomePage() {
            this.safeNavigate('/commonHelp');
        },
        callChapter1() {
            this.safeNavigate('/usermanualChapter1');
        },
        callChapter2() {
            this.safeNavigate('/usermanualChapter2');
        },
        processBookAppointment() {
            window.open("https://kitrin.com/book-appointment", '_blank');
        },
        processConfiguration() {
            setTimeout(() => {
                this.$router.push("commonConfigurationBasic");
            }, 0);
        },
        processClient() {
            setTimeout(() => {
                this.$router.push("commonClients");
            }, 0);
        },
        processAppointment() {
            setTimeout(() => {
                this.$router.push("commonCalendar");
            }, 0);
        },
        processPayment() {
            setTimeout(() => {
                this.$router.push("commonFinancialInvoices");
            }, 0);
        },
        async onShowWelcomeChange() {

            try {
                if (this.skipWelcome === true) {
                    this.userConfiguration.showWelcome = 'N';
                } else {
                    this.userConfiguration.showWelcome = 'Y';
                }

                await userService.updateUserConfig(this.userStore.user.id, this.userConfiguration);

                try {
                    const [userConfigData] = await Promise.all([
                        UserService.getUserConfig(this.userStore.user.id)
                    ]);

                    this.userConfiguration = userConfigData.data;

                    if (this.userConfiguration.showWelcome === 'Y') {
                        this.skipWelcome = false;
                    } else {
                        this.skipWelcome = true;
                    }

                } catch (e) {
                    if (e.response && e.response.status === 401) {
                        this.$router.replace('/login');
                    } else {
                        this.userStore.clearUser();
                        this.$router.replace('/login');
                    }
                    return;
                }

                this.$toast.add({
                    severity: 'success',
                    summary: 'Successful',
                    detail: 'Configuration updated',
                    life: 3000
                });

            } catch (e) {
                this.$toast.add({
                    severity: 'error',
                    summary: 'Error',
                    detail: 'Failed to update configuration. Please try again.',
                    life: 3000
                });
            }

        }
    }
};
</script>

<style scoped>
a {
    text-decoration: none;
}
</style>
